import styled from '@emotion/styled'

export const SpinnerContainer = styled.div(({ theme }) => ({
  padding: '72px 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontWeight: theme.fontWeights.bold,
  color: 'lightgrey'
}))

export const ClosedStoresMessage = styled.h2(({ theme }) => ({
  color: theme.colors.textBold,
  [theme.mediaQueries.viewport7]: {
    fontSize: theme.fontSizes[5],
    padding: `0 ${theme.space[3]}px`
  }
}))
